let letters = "йцукенгшщзхъфывапролджэячсмитьбю".split("");
let winEnLayoutLookup = {};
{
    let en = "qwertyuiop[]asdfghjkl;'zxcvbnm,.";
    en.split("").forEach((c, i) => (winEnLayoutLookup[c] = letters[i]));
}
export { letters, winEnLayoutLookup };
